export default __webpack_public_path__ + "static/media/Univers-Condensed-Bold.af37b2b0.ttf";